import { render, staticRenderFns } from "./ReceivingGoods.vue?vue&type=template&id=c6d34f56&scoped=true&"
import script from "./ReceivingGoods.vue?vue&type=script&lang=js&"
export * from "./ReceivingGoods.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingGoods.vue?vue&type=style&index=0&id=c6d34f56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d34f56",
  null
  
)

export default component.exports